:host {
    --gsb-primary: var(--bs-primary, #c0003c);
    --gsb-secondary: var(--bs-secondary, #0a406e);
    --gsb-tertiary: var(--bs-tertiary, #fff);
    --gsb-quaternary: var(--bs-quaternary, #e9df2e);
    --gsb-body-color: var(--bs-body-color, #222);
    --gsb-body-bg: var(--bs-body-bg, #fff);
    --gsb-emphasis-color: var(--bs-emphasis-color, #222);
    --gsb-link-color: var(--bs-link-color, #0a406e);
    --gsb-border-color: var(--bs-border-color, var(--gsb-secondary));
    --gsb-highlight-color: var(--bs-highlight-color, #222);
    --gsb-bgcolor-1: var(--bs-bgcolor-1, #000);
    --gsb-bgcolor-2: var(--bs-bgcolor-2, #fff);
    --gsb-bgcolor-3: var(--bs-bgcolor-3, #09406e);
    --gsb-bgcolor-4: var(--bs-bgcolor-4, #f5f5f5);
    --gsb-bgcolor-5: var(--bs-bgcolor-5, #006533);
    --gsb-bgcolor-6: var(--bs-bgcolor-6, #e9df2e);
    --gsb-success: var(--bs-success, #00854a);
    --gsb-info: var(--bs-info, #cfdce8);
    --gsb-warning: var(--bs-warning, #f7bb3d);
    --gsb-danger: var(--bs-danger, #c0003c);
    --gsb-light: var(--bs-light, #f2f3f4);
    --gsb-dark: var(--bs-dark, #4f4f4f);
}
